export default "__VITE_ASSET__B3_H1lq6__"